import useTeamContext from '@maxpreps/shared/contexts/TeamContext';
import SchoolTeamHeader from '@maxpreps/shared/corecomponents/SchoolTeamHeader/SchoolTeamHeader';
import { getIsCoreSport } from '@maxpreps/shared/functions/utils/teamUtils';
import useIsUserATeamAdmin from '../../utils/useIsUserATeamAdmin';
import { ITeamPageConfig } from './../../utils/ITeamPageConfig';
import AdminHeaderButton from './Admin/AdminHeaderButton';
import FollowButton from './FollowButton';

const TeamHeader: React.FC<{ pageConfig: ITeamPageConfig }> = ({
  pageConfig
}) => {
  const teamContext = useTeamContext();
  const isTeamAdmin = useIsUserATeamAdmin();

  const { data, mostRecentAdminGenderSportSeasonLevel } = teamContext;

  const {
    schoolCanonicalUrl,
    schoolName,
    schoolMascot,
    schoolMascotUrl,
    stateCode,
    schoolCity,
    level,
    gender,
    sport,
    sportSeasonId
  } = data;

  const title = `${schoolName} ${schoolMascot ?? ''}`;
  const subTitle = `${level} ${gender} ${sport}`;

  const isCoreSport = getIsCoreSport(teamContext.sportData);

  // isTeamAdmin AND NOT previous season custom/limited sport
  const isAdminDropdowVisible =
    pageConfig?.adminConfig &&
    isTeamAdmin &&
    !(
      mostRecentAdminGenderSportSeasonLevel.sportSeasonId !== sportSeasonId &&
      !isCoreSport
    );

  const rightAction = isAdminDropdowVisible ? (
    <AdminHeaderButton
      page={pageConfig.page}
      publicPageKey={pageConfig?.adminConfig?.publicPageKey}
      adminPageKey={pageConfig?.adminConfig?.adminPageKey}
    />
  ) : (
    <FollowButton />
  );

  return (
    <SchoolTeamHeader
      schoolName={schoolName}
      schoolMascotUrl={schoolMascotUrl}
      schoolCanonicalUrl={schoolCanonicalUrl}
      schoolCity={schoolCity}
      schoolStateCode={stateCode}
      title={title}
      subTitle={subTitle}
      rightAction={rightAction}
    />
  );
};

export default TeamHeader;
